import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import JourneyProfileService from "../List/JourneyProfileService";
import CheckAccess from "../../Roles/CheckAccess";
import PreLoadSpinner from "../../PreLoadSpinner";
import Cs from "../../../services/CommonService";
import querystringify from "querystringify";
import useModal from "../../../hooks/useModal";
import Tabs, { TabPane } from "rc-tabs";
import { CommentsBtn } from "../../Modals/Comments";
import GenericModal from "../../Modals/GenericModal";
import { AudioRecordingBtn } from '../../AudioRecordings/List';
import { usePageTitle } from "../../../hooks/pageHead";
import SideMenuBar from "../../Common/SideMenuBar";
import CTLazyLoad from "../../Common/CTLazyLoad";
import { tabMoreIcon } from "../../Common/Button";
import { getLocale } from '../../FormBuilder/FieldLabel';
import { usePageLocale } from '../../../hooks/useLocale';
import { LocalizeContext } from "../../../contexts/Localize/LocalizeStateProvider";
import { CueTip } from "../../Common/CueTooltip";
import { JourneyContext } from '../List/JourneyContext';
import { useSubscriptionAccess } from '../../Subscriptions/useSubscription';
import { useCurrentUserHook } from "../../Authentication/useUserHook";
import { MemberCaseAlert } from "../../Organizations/Members/MemberCaseAlerts.js";
import Components from './Components';
import { NavIcon } from "../../Common/MenuItem";

const PortalPage = (props) => {
  const css = ['/css/tab_banner_layout.css'];
  
  let params = props.match.params;
  let queryParam = querystringify.parse(props.location.search);
  
  let {current:scope} = useRef({ 'extraProps':{}, 'tabs':{} });

  const {currentUser} = useCurrentUserHook();
  const currentOrgMember = currentUser?.current_member || {};

  const {localeState:{portalPage}, localeDispatch} = useContext(LocalizeContext);
  const {journeyState:{dataSource:dsCaseList}, journeyDispatch} = useContext(JourneyContext);

  const {labelLocale} = usePageLocale(currentUser.current_locale, 'portalPage');
  const {subscriptionAccesses} = useSubscriptionAccess();

  const [loading, setLoading] = useState(true);
  const [journey, setJourney] = useState({});
  const [pageIds, setPageIds] = useState(['case_portal_page']);
  const [pptTabKey, setPptTabKey] = useState('');
  const [processTabKey, setProcessTabKey] = useState('');
  const [activityReloadTab, setActivityReloadTab] = useState();

  const { isOpen: isAudioRecorderOpen, toggleModal:toggleAudioRecorder } = useModal();

  usePageTitle(journey?.data?.name);

  useEffect(() => {
    getJourneyProfile();
  }, [currentUser.current_locale])
  
  const getJourneyProfile = async () =>{
    let req = {
      'locale':currentUser.current_locale
    }

    setLoading(true);

    const {status, data} = await JourneyProfileService.getPortal(params.journey_profile_id, req);
    if(status === 200){
      setJourney(data.journey_profile);
      scope.tabs.firstTabs = data.data_sources.path_nodes_startups?.options;
      setProcessTabKey('implement');
      journeyDispatch({
        "type":"ACTIVE",
        "payload": {'activeJourney': data.journey_profile}
      });
      /*localeDispatch({
        "type": "UPDATE",
        "payload": {
          'portalPage': res.page_locale?.caseportal_page_elements,
          'childBirthTab': res.page_locale?.birth_details_tab,
          'motherTab': res.page_locale?.mother_tab_locale,
          'commonTableHeaders': res.page_locale?.general_table_fields,
          'accessBFTable': res.page_locale?.access_bf_table,
          'accessCFTable': res.page_locale?.assess_cf_locale,
          'scheduleAlert': res.data_source_list?.upcoming_visits_alerts
        }
      });*/
      setLoading(false);
    }    
  }

  const getJourneyTypeLabel = () =>{
    
  }

  const openAudioRecorder = (e) =>{
    toggleAudioRecorder(e);
  }

  let onSecondTabChange = (key) => {
    setProcessTabKey(key);
    const preFix = queryParam.type === 'infant_journey'?'mcj_':'';
    //setActiveKey(key)
    setPageIds([pageIds[0], preFix+key]);
  }

  const reloadActivity = (tab) => {
    setProcessTabKey(tab);
    setActivityReloadTab(tab);
  } 

  const updateStatus = (idx, req, callbackFn) =>{
    JourneyProfileService.update(req).then((res)=>{
      if(res.status === 204){
        journeyDispatch({
          'type': "UPDATE_BY_ID",
          'id':req.id,
          'payload':req
        })
        setJourney({...journey, ...req})
        callbackFn && callbackFn(req)
      }
    })
  }

  if(loading) 
    return <PreLoadSpinner />

  const TabEle = ({tab}) => {
    const tabLocale = useMemo(() => {
      return{
        'label' : getLocale(tab, currentUser.current_locale, 'label'),
        'detail' : getLocale(tab, currentUser.current_locale, 'detail')
      }
    }, [tab.sid]);

    return <span data-tip={tabLocale.detail}>{tabLocale.label}</span>
  }

  return (
    <CTLazyLoad css={css}>
      <div id="ct">
        <div className="app-content m-t-15">
          <div className="bg-white brd-10 flex justspacebetween m-b-20 p10 m-t-20">
            <div>
              <h2 className="m-r-30 f18-xss">
                {journey.data.name}
              </h2>
              <p className="f14">{journey.data.details}</p>
            </div>
            <div className="flex aligncenter">
              <AudioRecordingBtn 
                journey={journey} 
                currentUser={currentUser} 
                onInitOpen={queryParam.popup === 'audio'}/>
              
              <CommentsBtn item={journey} 
                currentUser={currentUser} 
                onInitOpen={queryParam.popup === 'comments'}
                commentableType="journey_profile" 
                commentableId={journey.id}/>
            </div>
          </div>  

          <div id="case_process_details" className="app-header flex justspacebetween card bg-white brd-10 m-t-30 m-t-20-xs b-tab active">
            <Tabs activeKey={processTabKey} onChange={onSecondTabChange} moreIcon={tabMoreIcon}>
              {scope.tabs.firstTabs?.map((tab, key) =>
                <TabPane tab={<TabEle tab={tab}/>} key={tab.sid}>
                  <Components componentName={tab.sid} 
                    journeyProfile={journey} 
                    tabDsItem={tab} 
                    defaultViewType="activityTable"
                    {...scope.extraProps}/>      
                </TabPane>
              )}  
            </Tabs>
          </div>

          <div className="text-gray pos-abs r-40 m-t-5">
            {currentUser.current_organization.record_id} - {journey.record_id}
          </div>              

        </div>
      </div>

      <SideMenuBar pageIds={pageIds}/>
      
      <div className="m-b-80" />

    </CTLazyLoad>
  )
}

export default PortalPage;